import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import qs from "qs";
import axios from "axios";
import global_ from '@/misc/global.vue';

// 数据：
// 保存用户信息：userInfo
// 保存用户登录状态：userLogin
// 方法：
// 用户登录：login
// 用户退出：logout
// 显示登录页面：showLogin
// 显示用户登录提示信息：showLoginMessage
// 获取用户账号信息：getUserInfo
// 发送用户登录验证码：sendSMS


export const users = {
  namespaced: true,

  state: {
    // 保存用户所有相关信息
    userInfo: {
      'username': localStorage.getItem('username'),
      'userid': localStorage.getItem('userid'), // 通过用户名获取用户ID，后续将通过用户ID回写用户账号金额变动信息
      'password': '', // 用户口令不保存到本地
      'token': localStorage.getItem('token'), // 用户的JWTtoken
      'authTime': localStorage.getItem('authTime'), // 用户的通过认证的时间 
      'account1': localStorage.getItem('account1'), // 实际充值余额
      'account2': localStorage.getItem('account2'), // 赠送费用余额
      'authenticated': localStorage.getItem('token') && (new Date().getTime() - localStorage.getItem('authTime')) /
        (1000 * 60 * 60) < 24,
    },
    userLogin: {
      message: "欢迎登录 1DING GRC 平台。",
    },
    consumptionHistory: []
  },

  mutations: {
    // 用户登录
    login(state, params) {
      let postData = qs.stringify({
        username: params.username,
        password: params.password
      });
      axios({
        method: "post",
        async: false,
        url: global_.BAK_URL + "auth/obtain_token/",
        data: postData
      }).then(response => {
        // 缓存数据
        Vue.set(state.userInfo, 'authenticated', true)
        Vue.set(state.userInfo, 'username', params.username)
        Vue.set(state.userInfo, 'token', response.data.token)
        Vue.set(state.userInfo, 'authTime', new Date().getTime())
        Vue.set(state.userLogin, 'visible', false)
        // 保存到本地，在1天之内免登录
        localStorage.setItem('username', params.username)
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('authTime', new Date().getTime())
        // 在认证通过之后，获取用户账号信息
        axios({
          method: "get",
          async: false,
          url: global_.BAK_URL + "userInfo/"
        }).then(response => {
          Vue.set(state.userInfo, 'userid', response.data.id)
          Vue.set(state.userInfo, 'account1', response.data.account1)
          Vue.set(state.userInfo, 'account2', response.data.account2)
          // 保存到本地，在1天之内免登录
          localStorage.setItem('userid', response.data.id)
          localStorage.setItem('account1', response.data.account1)
          localStorage.setItem('account2', response.data.account2)
          this.dispatch('order/setRechargeInfo', 5000, {
            root: true
          })
          this.dispatch('order/updateOnceInfo', {}, {
            root: true
          })
          this.dispatch('users/getConsumptionHistory', {}, {
            root: true
          })
        })
      })
    },

    // 用户退出登录时，清除所有相关信息
    logout(state) {
      localStorage.clear()
      Vue.set(state.userInfo, 'username', null)
      Vue.set(state.userInfo, 'userid', null)
      Vue.set(state.userInfo, 'password', null)
      Vue.set(state.userInfo, 'token', null)
      Vue.set(state.userInfo, 'authTime', null)
      Vue.set(state.userInfo, 'account1', null)
      Vue.set(state.userInfo, 'account2', null)
      Vue.set(state.userInfo, 'authenticated', false)
      Vue.set(state.userLogin, 'message', "欢迎登录 1DING GRC 综合服务平台")
      Vue.set(state, 'consumptionHistory', [])
      this.dispatch('order/setRechargeInfo', 0.1, {
        root: true
      })
      this.dispatch('order/setOnceInfo', {}, {
        root: true
      })
    },

    showLoginMessage(state, params) {
      // 显示用户登录时的提示信息，如登录错误，验证码已发送等
      Vue.set(state.userLogin, 'message', params)
    },

    //获取验证码， 并将获取验证的结果反馈给用户
    sendSMS(state, params) {
      let postData = qs.stringify({
        mobile: params,
      });
      axios({
        method: "post",
        async: false,
        url: global_.BAK_URL + "sendsms/",
        data: postData
      }).then(response => {
        Vue.set(state.userLogin, 'message', response.data)
      })
    },

    // 在认证通过之后，获取用户账号信息
    getUserInfo(state) {
      if (state.userInfo.userid != null) {
        axios.get(global_.BAK_URL + "userInfo/").then(response => {
          Vue.set(state.userInfo, 'userid', response.data.id)
          Vue.set(state.userInfo, 'account1', response.data.account1)
          Vue.set(state.userInfo, 'account2', response.data.account2)
          // 保存到本地，在1天之内免登录
          localStorage.setItem('userid', response.data.id)
          localStorage.setItem('account1', response.data.account1)
          localStorage.setItem('account2', response.data.account2)
        }).catch(error => {
          localStorage.clear()
          Vue.set(state.userInfo, 'username', null)
          Vue.set(state.userInfo, 'userid', null)
          Vue.set(state.userInfo, 'password', null)
          Vue.set(state.userInfo, 'token', null)
          Vue.set(state.userInfo, 'authTime', null)
          Vue.set(state.userInfo, 'account1', null)
          Vue.set(state.userInfo, 'account2', null)
          Vue.set(state.userInfo, 'authenticated', false)
          Vue.set(state.userLogin, 'message', "欢迎登录 1DING GRC 综合服务平台")
          Vue.set(state, 'consumptionHistory', [])
          Vue.set(state, 'error', error)
        })
      }
    },

    getConsumptionHistory(state) {
      if (state.userInfo.userid != null) {
        axios.get(global_.BAK_URL + "consumptionHistory/").then(response => {
          Vue.set(state, 'consumptionHistory', response.data)
          localStorage.setItem('consumptionHistory', JSON.stringify(response.data))
          // 更新单次支付订单订单
          this.dispatch('order/updateOnceInfo', {}, {
            root: true
          })
        })
      }
    }
  },

  actions: {
    login: (context, params) => {
      context.commit("login", params)
    },
    logout: (context) => {
      context.commit("logout")
    },
    showLoginMessage: (context, params) => {
      context.commit('showLoginMessage', params)
    },
    // username: params,
    getUserInfo: (context) => {
      context.commit('getUserInfo')
    },
    sendSMS: (context, params) => {
      context.commit('sendSMS', params)
    },
    // 获取历史订单
    getConsumptionHistory(context) {
      context.commit('getConsumptionHistory')
    }
  }
}